// ── Variant picker selected state ─────────────────────────────────────────────
function applyVariantStyles() {
  document.querySelectorAll('variant-picker').forEach(function(picker) {
    picker.querySelectorAll('input[type="radio"]').forEach(function(input) {
      var label = input.closest('label');
      if (!label) return;
      if (input.checked) {
        label.style.setProperty('background-color', '#1A1A2E', 'important');
        label.style.setProperty('border-color', '#1A1A2E', 'important');
        label.style.setProperty('color', '#FAF8F5', 'important');
        var text = label.querySelector('.variant-option__button-label__text');
        if (text) text.style.setProperty('color', '#FAF8F5', 'important');
      } else {
        label.style.removeProperty('background-color');
        label.style.removeProperty('border-color');
        label.style.removeProperty('color');
        var text = label.querySelector('.variant-option__button-label__text');
        if (text) text.style.removeProperty('color');
      }
    });
  });
}

function deferredApply() {
  setTimeout(applyVariantStyles, 0);
  requestAnimationFrame(applyVariantStyles);
}

document.addEventListener('DOMContentLoaded', deferredApply);
document.addEventListener('change', function(e) {
  if (e.target && e.target.closest('variant-picker')) deferredApply();
});
document.addEventListener('click', function(e) {
  if (e.target && e.target.closest('variant-picker')) deferredApply();
});
document.addEventListener('shopify:section:load', deferredApply);
document.addEventListener('variant:changed', deferredApply);

var observer = new MutationObserver(function(mutations) {
  var relevant = mutations.some(function(m) {
    return Array.from(m.addedNodes).some(function(n) {
      return n.nodeType === 1 && (n.tagName === 'VARIANT-PICKER' || (n.querySelector && n.querySelector('variant-picker')));
    });
  });
  if (relevant) deferredApply();
});
observer.observe(document.body, { childList: true, subtree: true });

// ── Size guide modal ──────────────────────────────────────────────────────────
function initSizeGuide() {
  if (document.getElementById('lux-sg-modal')) return;

  // Inject modal HTML
  var modal = document.createElement('div');
  modal.id = 'lux-sg-modal';
  modal.setAttribute('aria-modal', 'true');
  modal.setAttribute('role', 'dialog');
  modal.setAttribute('aria-label', 'Size Guide');
  modal.innerHTML = [
    '<div id="lux-sg-overlay"></div>',
    '<div id="lux-sg-box">',
      '<div class="lux-sg-header">',
        '<h2 class="lux-sg-title">Size Guide</h2>',
        '<button class="lux-sg-close" aria-label="Close">✕</button>',
      '</div>',
      '<div class="lux-sg-tabs">',
        '<button class="lux-sg-tab lux-sg-tab--active" data-panel="mens">Men\'s</button>',
        '<button class="lux-sg-tab" data-panel="womens">Women\'s</button>',
      '</div>',
      '<div class="lux-sg-panel lux-sg-panel--active" id="lux-sg-panel-mens">',
        '<p class="lux-sg-note">All measurements are approximate. If between sizes, we recommend sizing up.</p>',
        '<table class="lux-sg-table"><thead><tr><th>EU</th><th>UK</th><th>US</th></tr></thead><tbody>',
          '<tr><td>40</td><td>6</td><td>7</td></tr>',
          '<tr><td>41</td><td>7</td><td>8</td></tr>',
          '<tr><td>42</td><td>8</td><td>9</td></tr>',
          '<tr><td>43</td><td>9</td><td>10</td></tr>',
          '<tr><td>44</td><td>10</td><td>11</td></tr>',
          '<tr><td>45</td><td>11</td><td>12</td></tr>',
          '<tr><td>46</td><td>12</td><td>13</td></tr>',
          '<tr><td>47</td><td>13</td><td>14</td></tr>',
        '</tbody></table>',
      '</div>',
      '<div class="lux-sg-panel" id="lux-sg-panel-womens">',
        '<p class="lux-sg-note">All measurements are approximate. If between sizes, we recommend sizing up.</p>',
        '<table class="lux-sg-table"><thead><tr><th>EU</th><th>UK</th><th>US</th></tr></thead><tbody>',
          '<tr><td>37</td><td>4</td><td>6</td></tr>',
          '<tr><td>38</td><td>5</td><td>7</td></tr>',
          '<tr><td>39</td><td>6</td><td>8</td></tr>',
          '<tr><td>40</td><td>7</td><td>9</td></tr>',
          '<tr><td>41</td><td>8</td><td>10</td></tr>',
          '<tr><td>42</td><td>9</td><td>11</td></tr>',
          '<tr><td>43</td><td>10</td><td>12</td></tr>',
          '<tr><td>44</td><td>11</td><td>13</td></tr>',
        '</tbody></table>',
      '</div>',
    '</div>'
  ].join('');
  document.body.appendChild(modal);

  // Inject a real clickable Size Guide button into each shoe-size fieldset legend
  document.querySelectorAll('variant-picker fieldset').forEach(function(fieldset) {
    var legend = fieldset.querySelector('legend');
    if (!legend || legend.querySelector('.lux-sg-trigger')) return;
    var btn = document.createElement('button');
    btn.className = 'lux-sg-trigger';
    btn.type = 'button';
    btn.textContent = 'Size Guide';
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      openSizeGuide();
    });
    legend.appendChild(btn);
  });

  // Event delegation
  document.addEventListener('click', function(e) {
    var el = e.target.closest('[data-lux-sg], .lux-sg-trigger');
    if (el && el.getAttribute('data-lux-sg')) {
      e.preventDefault();
      openSizeGuide();
    }
    if (e.target.classList.contains('lux-sg-trigger')) {
      openSizeGuide();
    }
    if (e.target.id === 'lux-sg-overlay' || e.target.classList.contains('lux-sg-close')) {
      closeSizeGuide();
    }
    if (e.target.classList.contains('lux-sg-tab')) {
      var panel = e.target.getAttribute('data-panel');
      document.querySelectorAll('.lux-sg-tab').forEach(function(t) { t.classList.remove('lux-sg-tab--active'); });
      document.querySelectorAll('.lux-sg-panel').forEach(function(p) { p.classList.remove('lux-sg-panel--active'); });
      e.target.classList.add('lux-sg-tab--active');
      document.getElementById('lux-sg-panel-' + panel).classList.add('lux-sg-panel--active');
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeSizeGuide();
  });
}

function openSizeGuide() {
  var m = document.getElementById('lux-sg-modal');
  if (m) { m.classList.add('lux-sg-open'); document.body.style.overflow = 'hidden'; }
}
function closeSizeGuide() {
  var m = document.getElementById('lux-sg-modal');
  if (m) { m.classList.remove('lux-sg-open'); document.body.style.overflow = ''; }
}

document.addEventListener('DOMContentLoaded', initSizeGuide);
document.addEventListener('shopify:section:load', initSizeGuide);

/* ── Collection description read more ── */
(function () {
  function initReadMore() {
    if (!document.querySelector('[data-template="collection"]')) return;
    var block = document.querySelector('.text-block--text_twGGkJ');
    if (!block) return;

    block.classList.add('lux-desc-wrap', 'is-collapsed');

    if (block.scrollHeight <= block.clientHeight + 2) {
      block.classList.remove('lux-desc-wrap', 'is-collapsed');
      return;
    }

    var btn = document.createElement('button');
    btn.className = 'lux-read-more-btn';
    btn.textContent = 'Read more';
    btn.addEventListener('click', function () {
      var collapsed = block.classList.toggle('is-collapsed');
      btn.textContent = collapsed ? 'Read more' : 'Read less';
    });
    block.insertAdjacentElement('afterend', btn);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReadMore);
  } else {
    initReadMore();
  }
})();

/* ── Scroll reveal — sections + cards ── */
(function () {
  function initReveal() {
    if (!window.IntersectionObserver) return;

    // Section-level reveal: skip first section (hero on homepage)
    var all = Array.from(document.querySelectorAll('[id^="shopify-section-"]'));
    if (all.length > 1) {
      var sectionObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('lux-section-visible');
            sectionObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.05 });

      all.slice(1).forEach(function (section) {
        var rect = section.getBoundingClientRect();
        if (rect.top > window.innerHeight * 0.85) {
          section.classList.add('lux-section-hidden');
        }
        sectionObserver.observe(section);
      });
    }

    // Card-level reveal: product-card and collection-card (replaces animation-timeline for Samsung Browser)
    var cardObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('lux-card-visible');
          cardObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });

    document.querySelectorAll('product-card, .collection-card, .blog-post-card').forEach(function (card) {
      var rect = card.getBoundingClientRect();
      if (rect.top > window.innerHeight * 0.9) {
        card.classList.add('lux-card-hidden');
        cardObserver.observe(card);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }
})();
